// extracted by mini-css-extract-plugin
module.exports = {"toptips":"TopTips_toptips_2L8DT","tipstxt":"TopTips_tipstxt_3MMd5","normalword":"TopTips_normalword_216IA","linkword":"TopTips_linkword_229WB"};